'use client';

import { useThemeContext } from '@/components/theme/ThemeProvider';

export function useTheme() {
  return useThemeContext();
}
